import React from 'react'

// Material-UI Core
import {withStyles, makeStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'

// Material-UI Icon
import LaunchIcon from '@material-ui/icons/Launch'

// Custom Component
import useLoading from "../Loading/useLoading"

// Custom Style
import {oceanBlueColor, grayColor, blackColor} from '../../styles/jss/cmsMainStyle'
import {drawingCardStyle} from '../../styles/jss/components/drawingCard/drawingCardStyle'


// Custom Style (Typography)
const CardFieldTypography = withStyles({
	root: {
		"fontSize": 18,
		"fontWeight": 400,
		"color": blackColor,
	},
}) (Typography)

const CardContentTypography = withStyles({
	root: {
		"fontSize": 18,
		"fontWeight": 400,
		"color": oceanBlueColor[12],
	},
}) (Typography)


const useStyles = makeStyles(theme => drawingCardStyle(theme))

const DrawingCard = props => {
	const {cardSourceData, cardButtonAction} = props
	const classes = useStyles()

	
	return (
		// console.log("Unpublish Packs Data (props parameter) | Variable: cardSourceData (DrawingCard.js)"),
		// console.log(cardSourceData),

		// console.log("---------------------------------------------------------------------------------"),


		cardSourceData ?
			<Grid container spacing={1}> 
			{
				cardSourceData.map((res, index) => {
					return (
						<Grid key={index} item xl={3} md={6} xs={12}>
							<Card className={classes.root}>
								<CardContent>
									<div className={classes.contentArea}>
										<CardFieldTypography className={classes.field}>Cover Type: </CardFieldTypography>
										<CardContentTypography variant="h4" className={classes.content}>{res.cover_type.type_name}</CardContentTypography>
									</div>

									<div className={classes.contentArea}>
										<CardFieldTypography className={classes.field}>Cover No.: </CardFieldTypography>
										<CardContentTypography variant="h4" className={classes.content}>
											{res.cover_type.contain_ai ? res.cover.ai_cover_no : res.cover_type.contain_bd ? res.cover.bd_cover_no : ""}
										</CardContentTypography>
									</div>

									<div className={classes.contentArea}>
										<CardFieldTypography variant="h5" component="h5" className={classes.field}>Title: </CardFieldTypography>
										<CardContentTypography variant="h5" component="h5" className={classes.content}>
											{res.cover_type.contain_ai ? res.cover.ai_cover_subject : res.cover_type.contain_bd ? res.cover.ai_cover_subject : ""}
										</CardContentTypography>
									</div>

									<div className={classes.contentArea}>
										<CardFieldTypography variant="h5" component="h5" className={classes.field}>Issue Date: </CardFieldTypography>
										<CardContentTypography variant="h5" component="h5" className={classes.content}>
											{res.cover_type.contain_ai ? res.cover.ai_issue_date : res.cover_type.contain_bd ? res.cover.ai_issue_date : ""}
										</CardContentTypography>
									</div>

									<div className={classes.contentArea}>
										<CardFieldTypography variant="h5" component="h5" className={classes.field}>Total Page: </CardFieldTypography>
										<CardContentTypography variant="h5" component="h5" className={classes.content}>
											{res.page ? res.page.remaining + " / " + res.page.total : ""}
										</CardContentTypography>
									</div>
								</CardContent>

								<CardActions>
									<Tooltip title="Open">
										<IconButton aria-label="Open" onClick={() => cardButtonAction(res.unpublish_seq)} className={classes.cardActionBtn}>
											<LaunchIcon />
										</IconButton>
									</Tooltip>
								</CardActions>
							</Card>
						</Grid>
					)
				})
			}
			</Grid>
		: ""
	)
}


export default DrawingCard